/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SummaryModel {
    getFixupPrototypeFunction() { return SummaryModel.fixupPrototype; }

    static newInstance(model: Partial<SummaryModel>): SummaryModel {
        let obj = Object.assign(new SummaryModel(), model);
        SummaryModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SummaryModel>): SummaryModel {
        if (!model) return null;
        return SummaryModel.newInstance(<SummaryModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SummaryModel) {
        if (!obj) return;

        models.SummaryModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SummaryModel): boolean {
        Object.setPrototypeOf(obj, SummaryModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Violations count for each violation category, i.e. Utilization/Standards
     */
    count: string;

    /**
     * Category of violations i.e Utilization/Standards
     */
    category: string;

}
